import MicroModal from "micromodal/dist/micromodal.min";

export default class findForm {
  constructor(form) {
    this._input = form.querySelector(`.js-input`);
    this._iconFind = form.querySelector(`.js-i-find`);
    this._iconClose = form.querySelector(`.js-i-close`);

    this._changeInput = this._changeInput.bind(this);
    this._iconCloseClickHandler = this._iconCloseClickHandler.bind(this);
    this._iconFindClickHandler = this._iconFindClickHandler.bind(this);
    this.init();
  }

  _changeInput() {
    if(this._input.value) {
      this._iconFind.style.display = 'none';
      this._iconClose.style.display = 'flex';
    }
    else {
      this._iconFind.style.display = 'flex';
      this._iconClose.style.display = 'none';
    }
  }

  _iconCloseClickHandler() {
    this._input.value = '';
    this._iconFind.style.display = 'flex';
    this._iconClose.style.display = 'none';
    this._input.focus();
  }

  _iconFindClickHandler() {
    this._input.focus();
  }

  init() {
    let _this = this;
    this._changeInput();
    this._input.oninput = function() {
      _this._changeInput();
    };
    if(this._iconClose) {
      this._iconClose.addEventListener(`click`, this._iconCloseClickHandler);
    }
    if(this._iconFind) {
      this._iconFind.addEventListener(`click`, this._iconFindClickHandler);
    }
    MicroModal.init({
      onClose: function (modal, triggerElement) {},
      onShow: function (modal, triggerElement) {_this._changeInput();},
      disableScroll: true,
    });
  }
}
